import { isEqual } from 'lodash';

/* eslint-disable-next-line */
type ProductTabButtonProps = {
  activeTab: string;
  tabLabel: string;
  switchTab: (tabLabel: string) => void;
};

export function ProductTabButton(props: ProductTabButtonProps) {
  const { activeTab, tabLabel, switchTab } = props;

  return (
    <button
      onClick={() => switchTab(tabLabel)}
      className={`${
        isEqual(activeTab, tabLabel) ? 'bg-headerBackground/50' : 'bg-white'
      } px-4 lg:px-12 font-MuseoSans100 text-caption lg:text-header6 hover:bg-headerBackground/50 transition-all duration-300`}
    >
      {tabLabel}
    </button>
  );
}

export default ProductTabButton;
